import { render, staticRenderFns } from "./LoginHeading.vue?vue&type=template&id=7b0878a8&scoped=true"
import script from "./LoginHeading.vue?vue&type=script&lang=js"
export * from "./LoginHeading.vue?vue&type=script&lang=js"
import style0 from "./LoginHeading.vue?vue&type=style&index=0&id=7b0878a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0878a8",
  null
  
)

export default component.exports